function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPorqueWaymenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-66"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 395.36,
    y1: 467.05,
    x2: 482.83,
    y2: 467.05,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 25.98,
    y1: 467.05,
    x2: 387.83,
    y2: 467.05,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-66"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 413.1,
    y1: 274.92,
    x2: 428.25,
    y2: 420.13,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 425.26,
    y1: 391.74,
    x2: 418.94,
    y2: 385.09,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421,387.26a7.81,7.81,0,0,0-2.74-5.83c-1.76-1.57-11-5.48-11.92-2.21C405.41,382.78,414.91,389.76,421,387.26Z",
    style: {
      fill: "#F09400",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 421.03,
    y1: 387.26,
    x2: 412.19,
    y2: 381.76,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 426.84,
    y1: 406.74,
    x2: 420.66,
    y2: 401.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.75,403.78A7.76,7.76,0,0,0,420,398c-1.76-1.58-11-5.48-11.92-2.21C407.13,399.29,416.63,406.27,422.75,403.78Z",
    style: {
      fill: "#F09400",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 422.75,
    y1: 403.78,
    x2: 413.91,
    y2: 398.27,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 420.97,
    y1: 350.4,
    x2: 414.73,
    y2: 344.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.82,347a7.75,7.75,0,0,0-2.73-5.82c-1.77-1.58-11-5.48-11.93-2.21C401.2,342.48,410.7,349.46,416.82,347Z",
    style: {
      fill: "#F09400",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 416.82,
    y1: 346.96,
    x2: 407.98,
    y2: 341.46,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 422.71,
    y1: 367.96,
    x2: 416.46,
    y2: 361.3,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.54,363.48a7.78,7.78,0,0,0-2.73-5.83c-1.76-1.57-11.05-5.48-11.93-2.21C402.93,359,412.43,366,418.54,363.48Z",
    style: {
      fill: "#F09400",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 418.54,
    y1: 363.48,
    x2: 409.71,
    y2: 357.97,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 418.19,
    y1: 324.34,
    x2: 411.93,
    y2: 317.96,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414,320.14a7.78,7.78,0,0,0-2.73-5.83c-1.77-1.58-11.05-5.48-11.93-2.21C398.4,315.65,407.9,322.64,414,320.14Z",
    style: {
      fill: "#F09400",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 414.02,
    y1: 320.14,
    x2: 405.19,
    y2: 314.63,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 415.18,
    y1: 295.65,
    x2: 409.12,
    y2: 291.02,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.21,293.19a7.78,7.78,0,0,0-2.74-5.82c-1.76-1.58-11-5.48-11.92-2.21C395.59,288.71,405.09,295.69,411.21,293.19Z",
    style: {
      fill: "#F09400",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 411.21,
    y1: 293.19,
    x2: 402.37,
    y2: 287.69,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 424.65,
    y1: 382.57,
    x2: 429.88,
    y2: 374.05,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.28,376.61a7.77,7.77,0,0,1,1.48-6.26c1.4-1.91,9.67-7.65,11.21-4.63C442.64,369,434.79,377.79,428.28,376.61Z",
    style: {
      fill: "#F09400",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 428.28,
    y1: 376.61,
    x2: 434.5,
    y2: 370.78,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 420.12,
    y1: 339.11,
    x2: 425.34,
    y2: 330.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.75,333.15a7.74,7.74,0,0,1,1.47-6.26c1.4-1.91,7.87-6.68,9.41-3.66C436.3,326.51,430.25,334.34,423.75,333.15Z",
    style: {
      fill: "#F09400",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 423.75,
    y1: 333.15,
    x2: 431.7,
    y2: 325.55,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 418.13,
    y1: 320.02,
    x2: 423.35,
    y2: 311.5,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.76,314.06a7.77,7.77,0,0,1,1.47-6.27c1.4-1.91,9.67-7.64,11.21-4.63C436.11,306.45,428.26,315.24,421.76,314.06Z",
    style: {
      fill: "#F09400",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 421.76,
    y1: 314.06,
    x2: 429.71,
    y2: 306.45,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 415.2,
    y1: 292.02,
    x2: 420.43,
    y2: 283.5,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.83,286.06a7.8,7.8,0,0,1,1.48-6.27c1.4-1.9,9.67-7.64,11.21-4.62C433.19,278.45,425.34,287.24,418.83,286.06Z",
    style: {
      fill: "#F09400",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 418.83,
    y1: 286.06,
    x2: 426.79,
    y2: 278.45,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413,274.12a7.77,7.77,0,0,1,1.47-6.27c1.4-1.9,9.68-7.64,11.21-4.62C427.32,266.51,419.47,275.3,413,274.12Z",
    style: {
      fill: "#F09400",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 412.97,
    y1: 274.12,
    x2: 420.92,
    y2: 266.51,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.43,274.45a7.8,7.8,0,0,1-6.08-2.13c-1.75-1.59-6.58-10.42-3.42-11.63C407.37,259.37,415.29,268.1,413.43,274.45Z",
    style: {
      fill: "#F09400",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 413.43,
    y1: 274.45,
    x2: 406.7,
    y2: 265.74,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 435.8,
    y1: 235.79,
    x2: 435.8,
    y2: 419.43,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 453.07,
    y1: 294.92,
    x2: 438,
    y2: 440.14,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 441.18,
    y1: 410.47,
    x2: 437.7,
    y2: 406.48,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.7,406.48a7.77,7.77,0,0,0-1.48-6.26c-1.4-1.91-9.68-7.64-11.21-4.62C423.34,398.88,431.19,407.67,437.7,406.48Z",
    style: {
      fill: "#F09400",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 437.7,
    y1: 406.48,
    x2: 430.18,
    y2: 399.28,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 445.44,
    y1: 369.01,
    x2: 440.26,
    y2: 364.69,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.88,366.18a7.77,7.77,0,0,0-1.48-6.26c-1.4-1.91-9.68-7.64-11.21-4.62C427.52,358.58,435.38,367.37,441.88,366.18Z",
    style: {
      fill: "#F09400",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 441.88,
    y1: 366.18,
    x2: 434.36,
    y2: 358.98,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 443.8,
    y1: 388.66,
    x2: 438.57,
    y2: 380.14,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.16,382.7a7.77,7.77,0,0,0-1.47-6.27c-1.4-1.9-9.68-7.63-11.22-4.61C425.8,375.1,433.66,383.89,440.16,382.7Z",
    style: {
      fill: "#F09400",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 440.16,
    y1: 382.7,
    x2: 432.65,
    y2: 375.49,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 448.06,
    y1: 342.55,
    x2: 443.07,
    y2: 336.8,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.66,339.36a7.81,7.81,0,0,0-1.47-6.27c-1.41-1.9-9.68-7.64-11.22-4.62C430.3,331.75,438.16,340.54,444.66,339.36Z",
    style: {
      fill: "#F09400",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 444.66,
    y1: 339.36,
    x2: 437.15,
    y2: 332.15,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 450.68,
    y1: 317.33,
    x2: 445.86,
    y2: 309.85,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.46,312.41a7.8,7.8,0,0,0-1.48-6.27c-1.4-1.9-9.68-7.63-11.21-4.61C433.1,304.81,441,313.6,447.46,312.41Z",
    style: {
      fill: "#F09400",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 447.46,
    y1: 312.41,
    x2: 439.94,
    y2: 305.2,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 442.21,
    y1: 402.64,
    x2: 449.08,
    y2: 395.38,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447,397.56a7.78,7.78,0,0,1,2.73-5.83c1.76-1.58,11-5.49,11.93-2.22C462.6,393.07,453.11,400.05,447,397.56Z",
    style: {
      fill: "#F09400",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 446.99,
    y1: 397.56,
    x2: 456.34,
    y2: 391.76,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 446.72,
    y1: 359.18,
    x2: 453.59,
    y2: 351.92,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.5,354.1a7.78,7.78,0,0,1,2.73-5.83c1.76-1.58,11-5.49,11.92-2.22C467.11,349.61,457.62,356.59,451.5,354.1Z",
    style: {
      fill: "#F09400",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 451.5,
    y1: 354.1,
    x2: 460.85,
    y2: 348.29,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 448.7,
    y1: 340.08,
    x2: 455.57,
    y2: 332.82,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.48,335a7.78,7.78,0,0,1,2.73-5.83c1.77-1.58,11-5.49,11.93-2.22C469.1,330.51,459.6,337.49,453.48,335Z",
    style: {
      fill: "#F09400",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 453.48,
    y1: 335,
    x2: 462.83,
    y2: 329.2,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 451.53,
    y1: 310.65,
    x2: 458.47,
    y2: 304.82,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.39,307a7.78,7.78,0,0,1,2.73-5.83c1.76-1.58,11-5.49,11.92-2.22C472,302.51,462.51,309.49,456.39,307Z",
    style: {
      fill: "#F09400",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 456.39,
    y1: 307,
    x2: 465.74,
    y2: 301.2,
    style: {
      fill: "#F09400",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.11,294.11a7.78,7.78,0,0,1,2.73-5.83c1.76-1.58,11-5.49,11.92-2.22C468.72,289.61,459.23,296.6,453.11,294.11Z",
    style: {
      fill: "#F09400",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 453.11,
    y1: 294.11,
    x2: 462.46,
    y2: 288.3,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.49,294.52a7.78,7.78,0,0,1-5.51-3.33c-1.38-1.91-4.3-11.55-1-12.09C450.66,278.52,456.61,288.7,453.49,294.52Z",
    style: {
      fill: "#F09400",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 453.49,
    y1: 294.52,
    x2: 448.7,
    y2: 284.61,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 435.55,
    y1: 391.48,
    x2: 429.86,
    y2: 383.88,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.71,386.26a7.78,7.78,0,0,0-2.11-6.08c-1.59-1.75-10.42-6.59-11.63-3.43C416.65,380.18,425.37,388.11,431.71,386.26Z",
    style: {
      fill: "#F09400",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 431.71,
    y1: 386.26,
    x2: 423.5,
    y2: 379.87,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 435.75,
    y1: 354.85,
    x2: 429.86,
    y2: 349.37,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.71,351.75a7.78,7.78,0,0,0-2.11-6.08c-1.59-1.75-10.42-6.59-11.63-3.43C416.65,345.67,425.37,353.6,431.71,351.75Z",
    style: {
      fill: "#F09400",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 431.71,
    y1: 351.75,
    x2: 423.5,
    y2: 345.36,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 435.94,
    y1: 316.79,
    x2: 429.86,
    y2: 308.86,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.71,311.24a7.77,7.77,0,0,0-2.11-6.08c-1.59-1.75-10.42-6.6-11.63-3.44C416.65,305.16,425.37,313.09,431.71,311.24Z",
    style: {
      fill: "#F09400",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 431.71,
    y1: 311.24,
    x2: 423.5,
    y2: 304.84,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 435.55,
    y1: 287.01,
    x2: 429.86,
    y2: 281.88,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.71,284.26a7.78,7.78,0,0,0-2.11-6.08c-1.59-1.75-10.42-6.59-11.63-3.43C416.65,278.18,425.37,286.11,431.71,284.26Z",
    style: {
      fill: "#F09400",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 431.71,
    y1: 284.26,
    x2: 423.5,
    y2: 277.87,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 435.88,
    y1: 260.02,
    x2: 429.98,
    y2: 255.7,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.71,257.17a7.78,7.78,0,0,0-2.11-6.08c-1.59-1.75-10.42-6.59-11.63-3.43C416.65,251.09,425.37,259,431.71,257.17Z",
    style: {
      fill: "#F09400",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 431.71,
    y1: 257.17,
    x2: 423.5,
    y2: 250.78,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 436.99,
    y1: 400.65,
    x2: 441.89,
    y2: 394.42,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440,396.8a7.78,7.78,0,0,1,2.11-6.08c1.59-1.75,10.42-6.59,11.63-3.43C455.11,390.72,446.38,398.65,440,396.8Z",
    style: {
      fill: "#F09400",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 440.04,
    y1: 396.8,
    x2: 448.74,
    y2: 390.06,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 435.81,
    y1: 347.47,
    x2: 441.89,
    y2: 339.54,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440,341.91a7.78,7.78,0,0,1,2.11-6.08c1.59-1.74,10.42-6.59,11.63-3.43C455.11,335.83,446.38,343.76,440,341.91Z",
    style: {
      fill: "#F09400",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 440.04,
    y1: 341.91,
    x2: 448.74,
    y2: 335.18,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 435.81,
    y1: 320.38,
    x2: 441.89,
    y2: 312.45,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440,314.82a7.76,7.76,0,0,1,2.11-6.07c1.59-1.75,10.42-6.6,11.63-3.44C455.11,308.75,446.38,316.68,440,314.82Z",
    style: {
      fill: "#F09400",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 440.04,
    y1: 314.82,
    x2: 448.74,
    y2: 308.09,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 435.81,
    y1: 284.57,
    x2: 441.89,
    y2: 276.64,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440,279a7.78,7.78,0,0,1,2.11-6.08c1.59-1.75,10.42-6.6,11.63-3.44C455.11,272.94,446.38,280.87,440,279Z",
    style: {
      fill: "#F09400",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 440.04,
    y1: 279.02,
    x2: 448.74,
    y2: 272.28,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 436.07,
    y1: 253.67,
    x2: 442.03,
    y2: 249.02,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440,250.87a7.78,7.78,0,0,1,2.11-6.08c1.59-1.75,10.42-6.6,11.63-3.44C455.11,244.79,446.38,252.72,440,250.87Z",
    style: {
      fill: "#F09400",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 440.04,
    y1: 250.87,
    x2: 448.74,
    y2: 244.13,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.45,238.38a7.78,7.78,0,0,1,2.11-6.08c1.59-1.75,10.42-6.59,11.63-3.43C450.51,232.3,441.79,240.23,435.45,238.38Z",
    style: {
      fill: "#F09400",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 435.45,
    y1: 238.38,
    x2: 444.15,
    y2: 231.65,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.87,238.76a7.78,7.78,0,0,1-5.82-2.74c-1.58-1.77-5.47-11.05-2.2-11.93C431.4,223.14,438.38,232.64,435.87,238.76Z",
    style: {
      fill: "#F09400",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 435.87,
    y1: 238.76,
    x2: 430.08,
    y2: 229.4,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "443.35 467.05 423.9 467.05 421.47 417.94 445.78 417.94 443.35 467.05",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-66"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "180.68 83.04 180.68 313.59 31.67 313.59 31.67 44.45 180.68 44.45 180.68 73.29",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 64.06,
    y1: 102.7,
    x2: 64.06,
    y2: 313.57,
    style: {
      fill: "#263238",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 64.06,
    y1: 45.13,
    x2: 64.06,
    y2: 95.19,
    style: {
      fill: "#263238",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 104.1,
    y1: 45.13,
    x2: 104.1,
    y2: 313.57,
    style: {
      fill: "#263238",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 144.15,
    y1: 149.63,
    x2: 144.15,
    y2: 313.57,
    style: {
      fill: "#263238",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 144.15,
    y1: 45.13,
    x2: 144.15,
    y2: 142.75,
    style: {
      fill: "#263238",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32.77,
    y1: 83.04,
    x2: 180.44,
    y2: 83.04,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32.77,
    y1: 121.21,
    x2: 180.44,
    y2: 121.21,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32.77,
    y1: 159.38,
    x2: 180.44,
    y2: 159.38,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32.77,
    y1: 197.55,
    x2: 180.44,
    y2: 197.55,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32.77,
    y1: 235.72,
    x2: 180.44,
    y2: 235.72,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 44.66,
    y1: 273.88,
    x2: 180.44,
    y2: 273.88,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32.77,
    y1: 273.88,
    x2: 39.66,
    y2: 273.88,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-66"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 195.73,
    y: 43.59,
    width: 173.85,
    height: 369.05,
    rx: 25.7,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.52,69.26V387a19.93,19.93,0,0,1-19.93,19.93H221.73a18.59,18.59,0,0,1-2.71-.19A19.94,19.94,0,0,1,201.79,387V69.26a19.93,19.93,0,0,1,19.94-19.93h3.54c11,0,40.5,1.13,42.66,3.29,3.44,3.44,7.46,8.14,12.71,8.69,5.49.56,9.85-3.88,13.42-7.41,4-4,9.37-4.57,14.8-4.57h34.73A19.93,19.93,0,0,1,363.52,69.26Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.09,394.06A20,20,0,0,0,219,406.7a18.59,18.59,0,0,0,2.71.19H343.59a19.93,19.93,0,0,0,18.61-12.83Z",
    style: {
      fill: "#F09400",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.52,71.06v-1.8a19.93,19.93,0,0,0-19.93-19.93H308.86c-5.43,0-10.79.6-14.8,4.57-3.57,3.53-7.93,8-13.42,7.41-5.25-.55-9.27-5.25-12.71-8.69-2.16-2.16-6.79-3.39-10.27-3.21,0-.1-21.43-.08-32.39-.08h-3.54a19.93,19.93,0,0,0-19.94,19.93v1.8Z",
    style: {
      fill: "#F09400",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 281.63,
    cy: 53.67,
    r: 3.51,
    style: {
      fill: "#7d7d7d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.52,149.75h0V103.82h0a3.15,3.15,0,0,1,3.15,3.15V146.6A3.15,3.15,0,0,1,369.52,149.75Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.52,189.34h0V166.42h0a3.15,3.15,0,0,1,3.15,3.15v16.62A3.15,3.15,0,0,1,369.52,189.34Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.19,306.86s.38,2,.77,2.13,4.16-.09,4.26-1.06-1.94-1.55-1.94-1.55Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.26,58.73h-1.71v-2a.41.41,0,0,0-.41-.41H331.91a.42.42,0,0,0-.41.41V65.1a.42.42,0,0,0,.41.42h15.23a.41.41,0,0,0,.41-.42v-2h1.71a.36.36,0,0,0,.36-.36V59.09A.36.36,0,0,0,349.26,58.73Zm-2.53,6h-2.58V57.16h2.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.93,
    y: 58.9,
    width: 3.67,
    height: 5.67,
    rx: 0.44,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.32,
    y: 57.22,
    width: 3.68,
    height: 7.35,
    rx: 0.44,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.71,
    y: 55.24,
    width: 3.67,
    height: 9.34,
    rx: 0.44,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282.8,
    cy: 144.78,
    r: 62.91,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 281.83,
    cy: 141.37,
    r: 62.91,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.72,103.66s-11.29,11.28-14.67,13.54-7.9,6.77-9.6,8.47-1.62,2.74,0,3.42,2.05,1.14,3.18-.46,9.79-8.42,11.15-9.78,3.64-2.28,5.69-5a30.81,30.81,0,0,1,3.42-4.09c.68-.69,4.32-1.82,4.55-3.87S260.72,103.66,260.72,103.66Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253,128.73S241.67,140,238.29,142.28s-7.9,6.77-9.6,8.46-1.63,2.74,0,3.43,2.05,1.13,3.18-.46,9.79-8.42,11.15-9.78,3.64-2.28,5.69-5a32,32,0,0,1,3.42-4.1c.68-.68,4.32-1.82,4.55-3.86S253,128.73,253,128.73Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.73,107.7s-2.27,4.32-3.18,5.69-5.92,8.19-7.51,10-4.78,6.6-5.47,7.28,0,3,0,3,1.6.68,2.28.91,2.5-1.82,3.19-3.19,6.59-10.24,7.73-11.83,5-3.64,5.69-7.28S272.37,106.33,268.73,107.7Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.07,134.2s-.42,5.33-.75,7.1-2.42,10.8-3.23,13.31-2,8.71-2.36,9.69,1.28,3,1.28,3,1.9,0,2.68-.07,1.73-2.91,1.83-4.58,2.22-13.15,2.68-15.25,3.47-5.82,2.58-9.78S235.15,131.25,232.07,134.2Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.55,115.86s-.42,5.34-.75,7.1-2.42,10.8-3.24,13.32-2,8.7-2.35,9.68,1.28,3,1.28,3,1.89,0,2.68-.06,1.73-2.92,1.83-4.59,2.22-13.15,2.68-15.24,3.47-5.83,2.58-9.79S242.63,112.92,239.55,115.86Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.87,106.08s-.39,4.87-.69,6.48-2.21,9.86-3,12.16-1.79,7.95-2.15,8.85,1.17,2.72,1.17,2.72,1.73,0,2.45-.06,1.58-2.66,1.67-4.19,2-12,2.45-13.92,3.17-5.32,2.36-8.93S261.67,103.39,258.87,106.08Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.16,109.9s-8.67,7.37-11.07,9.81-2.6,2.9-3.45,3.65a31.34,31.34,0,0,0-3.42,3.34c-.37.63.69,1.82,2.13,2.07s6.3-5.58,6.3-5.58,11.17-8.67,12.74-10.67,4.49-4.89,4.7-5.68-.3-3.08-2.13-2.07S247.16,109.9,247.16,109.9Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.53,125.59s-7.3,8.73-9.26,11.53-2.07,3.3-2.78,4.19a31.27,31.27,0,0,0-2.81,3.87c-.25.68,1,1.67,2.45,1.67s5.27-6.56,5.27-6.56,9.54-10.44,10.75-12.67,3.6-5.58,3.67-6.39-.81-3-2.45-1.68S247.53,125.59,247.53,125.59Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.44,97.91s-14.79,8.88-16.61,10-6.6,4.55-8.19,5.46a24.11,24.11,0,0,0-3,2s.23,2,1.59,2.28a5.71,5.71,0,0,0,4.33-1.14c.91-.91,12.06-8,13.88-9.33s6.37-3.18,7.05-3.87,2.51-.45,3-1.59S260.54,97.23,256.44,97.91Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.37,127.31s-14.79,8.88-16.61,10-6.6,4.55-8.19,5.46a22.7,22.7,0,0,0-3,2.05s.23,2,1.59,2.27a5.71,5.71,0,0,0,4.33-1.14c.91-.91,12.06-8,13.88-9.33s6.37-3.18,7.05-3.86,2.5-.46,3-1.6S258.47,126.63,254.37,127.31Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.1,133s-8.68,14.91-9.72,16.78-3.59,7.17-4.55,8.74a23.6,23.6,0,0,0-1.6,3.22s1.19,1.68,2.49,1.22a5.66,5.66,0,0,0,3.24-3.08c.36-1.23,6.73-12.79,7.66-14.86s4-5.87,4.32-6.79,2-1.61,1.82-2.83S253.36,130.4,250.1,133Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.73,143s-1.38,15.9-2.52,19.81-1.7,10.27-1.91,12.65.52,3.15,2.18,2.65,2.3-.45,2.14-2.4,2.08-12.74,2.25-14.66,1.33-4.09,1.14-7.5a30.9,30.9,0,0,1,0-5.33c.08-1,2.14-4.17,1-5.89S240.73,143,240.73,143Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.9,141s-5.62,16.31-6.28,18.35-2.13,7.73-2.76,9.45a22.65,22.65,0,0,0-1,3.47s1.49,1.42,2.68.72a5.72,5.72,0,0,0,2.58-3.65c.11-1.29,4.12-13.86,4.63-16.07s2.83-6.54,2.92-7.5,1.62-2,1.24-3.13S243.6,137.8,240.9,141Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.27,148s2.94,17,3.34,19.1,1.87,7.8,2.14,9.61a24.22,24.22,0,0,0,.84,3.5s2,.53,2.7-.66a5.7,5.7,0,0,0,.5-4.45c-.52-1.17-3.07-14.12-3.69-16.31s-.67-7.09-1.06-8,.48-2.5-.42-3.34S242.11,144,241.27,148Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.79,135.16s-1.39,15.91-2.53,19.81-1.69,10.27-1.9,12.65.51,3.15,2.17,2.65,2.3-.45,2.15-2.4,2.08-12.74,2.25-14.66,1.32-4.09,1.13-7.49a33.5,33.5,0,0,1,0-5.34c.09-1,2.14-4.17,1-5.89S252.79,135.16,252.79,135.16Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253,133.17s-5.62,16.31-6.29,18.35-2.12,7.73-2.76,9.45a24.08,24.08,0,0,0-.95,3.47s1.49,1.42,2.69.72a5.76,5.76,0,0,0,2.58-3.65c.11-1.29,4.11-13.86,4.63-16.07s2.83-6.54,2.91-7.5,1.63-2,1.24-3.12S255.66,130,253,133.17Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.33,140.25s2.94,17,3.34,19.1,1.86,7.8,2.14,9.61a22.78,22.78,0,0,0,.84,3.5s2,.53,2.7-.66a5.74,5.74,0,0,0,.5-4.45c-.52-1.17-3.08-14.12-3.7-16.31s-.67-7.09-1.06-8,.48-2.5-.42-3.34S254.17,136.18,253.33,140.25Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.44,104s-14.67-6.28-18-8.58S289.19,90.64,287,89.7s-3.15-.5-3.19,1.23-.3,2.33,1.61,2.79,11.45,6,13.22,6.72,3.47,2.53,6.77,3.42a31.82,31.82,0,0,1,5.07,1.64c.89.38,3.29,3.34,5.28,2.79S316.44,104,316.44,104Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.28,106.16s-14.68-6.28-18-8.59-9.22-4.81-11.43-5.76-3.14-.49-3.19,1.24-.29,2.33,1.61,2.79,11.45,6,13.23,6.71,3.46,2.54,6.76,3.42a31.67,31.67,0,0,1,5.07,1.65c.89.38,3.3,3.34,5.29,2.79S290.28,106.16,290.28,106.16Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.67,113s-4.86-.51-6.47-.84-9.8-2.45-12.08-3.25-7.91-2-8.79-2.36-2.75,1.09-2.75,1.09,0,1.74,0,2.46,2.62,1.64,4.14,1.77,12,2.32,13.86,2.78,5.24,3.3,8.88,2.58S318.29,115.85,315.67,113Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.89,86.83s-4.66,1.45-6.27,1.77-10,1.62-12.39,1.78-8.05,1.29-9,1.29-2.09,2.1-2.09,2.1.64,1.6,1,2.25,3.06.48,4.51,0,11.91-2.59,13.84-2.91,6.11,1,9.17-1.13S300.43,88.44,296.89,86.83Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.5,103.22s-4.66,1.45-6.27,1.77-10,1.62-12.39,1.78-8,1.29-9,1.29-2.09,2.09-2.09,2.09.64,1.61,1,2.26,3.05.48,4.5,0,11.91-2.58,13.84-2.9,6.11,1,9.17-1.13S317,104.83,313.5,103.22Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.9,118.81s-10.06-5.31-13.21-6.64-3.67-1.33-4.68-1.84a30.5,30.5,0,0,0-4.37-1.94c-.72-.1-1.43,1.32-1.13,2.75s7.53,3.77,7.53,3.77,12.2,7.15,14.64,7.86,6.2,2.36,7,2.26,2.75-1.43,1.13-2.75S289.9,118.81,289.9,118.81Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.18,100S280.36,96.42,277,95.64s-3.83-.69-4.92-1a30.56,30.56,0,0,0-4.64-1.17c-.72,0-1.18,1.54-.64,2.89s8.05,2.45,8.05,2.45,13.23,5,15.76,5.27,6.51,1.27,7.3,1,2.47-1.86.64-2.89S291.18,100,291.18,100Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.48,123s-13.73-10.44-15.47-11.7-6.68-4.44-8.11-5.58a23.29,23.29,0,0,0-3-2s-1.82,1-1.52,2.32a5.68,5.68,0,0,0,2.66,3.59c1.18.51,11.88,8.24,13.82,9.42s5.33,4.73,6.21,5.11,1.36,2.16,2.58,2.16S306.64,126.51,304.48,123Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.12,106.94s-13.74-10.43-15.47-11.7-6.68-4.43-8.12-5.57a23.22,23.22,0,0,0-3-2s-1.81,1-1.52,2.33a5.71,5.71,0,0,0,2.67,3.59c1.18.5,11.87,8.23,13.82,9.42s5.32,4.73,6.21,5.11,1.35,2.15,2.58,2.15S294.28,110.49,292.12,106.94Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.28,105.08s-17.06-2.51-19.19-2.79-8-.66-9.8-1a24.16,24.16,0,0,0-3.59-.29s-1.12,1.73-.21,2.77a5.71,5.71,0,0,0,4.07,1.86c1.28-.13,14.37,1.49,16.65,1.59s6.94,1.57,7.9,1.48,2.23,1.23,3.3.64S288.88,107.15,285.28,105.08Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.53,100.1s-15.28,4.62-19.33,5-10.16,2.24-12.45,2.94-2.73,1.64-1.65,3,1.27,2,3,1.1,12.6-2.81,14.45-3.36,4.28-.29,7.37-1.73a32,32,0,0,1,4.95-2c.92-.28,4.67.43,5.83-1.27S272.53,100.1,272.53,100.1Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.45,99.51s-17.23.84-19.37,1-8,.9-9.8,1a23.2,23.2,0,0,0-3.58.41s-.76,1.91.33,2.75a5.7,5.7,0,0,0,4.35,1c1.23-.37,14.39-1.33,16.64-1.67s7.12.19,8.05-.08,2.42.78,3.36,0S278.38,100.84,274.45,99.51Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268,102.48s-14.68,9-16.49,10.21-6.55,4.63-8.13,5.56a22.44,22.44,0,0,0-2.93,2.08s.25,2,1.62,2.26a5.72,5.72,0,0,0,4.31-1.19c.9-.92,12-8.11,13.77-9.49s6.33-3.26,7-4,2.49-.49,2.94-1.63S272.1,101.75,268,102.48Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.87,162.86c-7.24,0-13.11,5.32-13.11,11.88s5.87,11.88,13.11,11.88S318,181.3,318,174.74,312.11,162.86,304.87,162.86Zm5.73,4.71c.44,1.07-3.53,4.71-4.63,4.71s-2.64-5.78-2.64-5.78C306.41,165,310.16,166.5,310.6,167.57Zm-15,3.21a7.92,7.92,0,0,1,3.09-3.64s2.42-.85,2.42.43,2,2.14,2,4.07-3.08.21-5.28.86S294.73,173.14,295.61,170.78ZM298,180.84c-1.33-.42-3.31-4.06-2.87-4.92s6.39-1.07,6.39-1.07a1.59,1.59,0,0,1,1.54,2.57C302,178.7,299.36,181.27,298,180.84Zm9.69,1.72c-1.32.42-4.63.42-5.07-.43s3.09-5.14,3.09-5.14,1.32-1.28,2.42-.21A13.17,13.17,0,0,1,311,180.2C311.48,181.27,309.05,182.13,307.73,182.56Zm5.95-4.71-4-3.21c-2.21-1.07,1.32-3.21,2.86-4.07s2.42-.86,3.08,2.35A4.86,4.86,0,0,1,313.68,177.85Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319,107c-7.25,0-13.12,5.31-13.12,11.88s5.87,11.88,13.12,11.88,13.11-5.32,13.11-11.88S326.24,107,319,107Zm5.72,4.7c.44,1.07-3.52,4.71-4.62,4.71s-2.65-5.78-2.65-5.78C320.54,109.14,324.28,110.63,324.72,111.7Zm-15,3.22a7.86,7.86,0,0,1,3.09-3.64s2.42-.86,2.42.42,2,2.14,2,4.07-3.08.22-5.29.86S308.86,117.27,309.74,114.92ZM312.16,125c-1.32-.43-3.3-4.07-2.86-4.93s6.39-1.07,6.39-1.07a1.6,1.6,0,0,1,1.54,2.57C316.13,122.84,313.49,125.4,312.16,125Zm9.7,1.71c-1.32.43-4.63.43-5.07-.43s3.09-5.14,3.09-5.14,1.32-1.28,2.42-.21a13.12,13.12,0,0,1,2.86,3.42C325.61,125.4,323.18,126.26,321.86,126.69Zm5.95-4.71-4-3.21c-2.2-1.07,1.32-3.21,2.87-4.07s2.42-.86,3.08,2.36A4.85,4.85,0,0,1,327.81,122Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.61,170.57c-7.24,0-13.11,5.32-13.11,11.88s5.87,11.88,13.11,11.88,13.11-5.32,13.11-11.88S286.85,170.57,279.61,170.57Zm5.73,4.71c.44,1.07-3.53,4.71-4.63,4.71s-2.64-5.78-2.64-5.78C281.15,172.71,284.9,174.21,285.34,175.28Zm-15,3.21a7.92,7.92,0,0,1,3.09-3.64s2.42-.86,2.42.43,2,2.14,2,4.07-3.09.21-5.29.85S269.47,180.84,270.35,178.49Zm2.43,10.06c-1.32-.43-3.31-4.07-2.87-4.92s6.39-1.07,6.39-1.07a1.6,1.6,0,0,1,1.55,2.57C276.74,186.41,274.1,189,272.78,188.55Zm9.69,1.71c-1.32.43-4.62.43-5.06-.43s3.08-5.13,3.08-5.13,1.32-1.29,2.42-.22a13,13,0,0,1,2.87,3.43C286.22,189,283.8,189.83,282.47,190.26Zm5.95-4.71-4-3.21c-2.21-1.07,1.32-3.21,2.86-4.06s2.43-.86,3.09,2.35A4.85,4.85,0,0,1,288.42,185.55Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.47,146.72c0-3.1,2.94-6.58,2.21-9.44s-5-4.43-6.41-7-.55-7.2-2.59-9.33-6.38-1.2-8.89-2.73-3.85-5.94-6.68-6.73-6,2.33-9,2.33-6.26-3.1-9-2.33-4.21,5.23-6.68,6.74-6.86.58-8.89,2.72-1.14,6.7-2.59,9.34-5.66,4.05-6.41,7,2.21,6.34,2.21,9.44-2.94,6.58-2.21,9.45,5,4.43,6.41,7,.55,7.2,2.59,9.34,6.38,1.2,8.89,2.72,3.86,5.94,6.68,6.74,6-2.33,9-2.33,6.26,3.09,9,2.33,4.21-5.24,6.69-6.74,6.85-.58,8.88-2.72,1.14-6.7,2.59-9.34,5.66-4.05,6.41-7S321.47,149.83,321.47,146.72Z",
    style: {
      fill: "#F09400",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.63,142.48c0-3,2.81-6.27,2.11-9s-4.74-4.21-6.1-6.69-.53-6.86-2.47-8.9-6.08-1.14-8.47-2.59-3.68-5.66-6.37-6.41-5.74,2.21-8.56,2.21-6-2.94-8.57-2.21-4,5-6.37,6.41-6.53.56-8.46,2.59-1.09,6.39-2.47,8.9-5.39,3.86-6.11,6.69,2.11,6,2.11,9-2.8,6.27-2.11,9,4.75,4.22,6.11,6.69.53,6.86,2.47,8.9,6.08,1.14,8.47,2.59,3.67,5.66,6.36,6.42,5.75-2.22,8.57-2.22,6,2.95,8.56,2.22,4-5,6.37-6.42,6.53-.56,8.47-2.59,1.08-6.39,2.47-8.9,5.38-3.86,6.1-6.69S328.63,145.44,328.63,142.48Z",
    style: {
      fill: "#F09400",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 293.08,
    cy: 143.65,
    r: 33,
    transform: "translate(49.98 361.45) rotate(-67.97)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.53,131.59c0,1.26-1.48,2.28-1.48,2.28s-1.48-1-1.48-2.28,1.48-2.27,1.48-2.27S288.53,130.33,288.53,131.59Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.15,159.12c0,1.26-1.48,2.28-1.48,2.28s-1.48-1-1.48-2.28,1.48-2.27,1.48-2.27S310.15,157.87,310.15,159.12Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.81,131.82c0,1.26-1.48,2.27-1.48,2.27s-1.48-1-1.48-2.27,1.48-2.28,1.48-2.28S276.81,130.56,276.81,131.82Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.3,127.7c1.18.45,1.61,2.19,1.61,2.19a3.41,3.41,0,0,1-2.65.58c-1.18-.44-1.61-2.19-1.61-2.19A3.45,3.45,0,0,1,309.3,127.7Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.51,120.07c1.17.45,1.6,2.19,1.6,2.19a3.4,3.4,0,0,1-2.65.58c-1.17-.44-1.6-2.19-1.6-2.19A3.44,3.44,0,0,1,283.51,120.07Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.73,158.88c1.17.44,1.6,2.19,1.6,2.19a3.44,3.44,0,0,1-2.65.58c-1.17-.45-1.6-2.19-1.6-2.19A3.44,3.44,0,0,1,284.73,158.88Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.86,146.36c1.17.45,1.6,2.19,1.6,2.19a3.44,3.44,0,0,1-2.65.58c-1.17-.44-1.6-2.19-1.6-2.19A3.44,3.44,0,0,1,280.86,146.36Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.53,150.46c1.17.44,1.61,2.19,1.61,2.19a3.47,3.47,0,0,1-2.66.58c-1.17-.45-1.6-2.19-1.6-2.19A3.44,3.44,0,0,1,271.53,150.46Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.56,120c1.18.44,1.61,2.18,1.61,2.18a3.46,3.46,0,0,1-2.66.59c-1.17-.45-1.6-2.19-1.6-2.19A3.4,3.4,0,0,1,296.56,120Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.78,154.77c1.17.44,1.6,2.18,1.6,2.18a3.4,3.4,0,0,1-2.65.58c-1.17-.44-1.6-2.18-1.6-2.18A3.4,3.4,0,0,1,295.78,154.77Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.66,140.67c1.17.45,1.6,2.19,1.6,2.19a3.4,3.4,0,0,1-2.65.58c-1.18-.44-1.61-2.18-1.61-2.18A3.46,3.46,0,0,1,300.66,140.67Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.58,134.3c1.18.45,1.61,2.19,1.61,2.19a3.44,3.44,0,0,1-2.65.58c-1.18-.44-1.61-2.19-1.61-2.19A3.45,3.45,0,0,1,316.58,134.3Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.63,144.42c1.18.45,1.61,2.19,1.61,2.19a3.44,3.44,0,0,1-2.65.58C310.41,146.75,310,145,310,145A3.45,3.45,0,0,1,312.63,144.42Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.1,173.35c-7,0-12.73,5.32-12.73,11.88s5.7,11.88,12.73,11.88,12.74-5.32,12.74-11.88S275.14,173.35,268.1,173.35Zm5.57,4.71c.43,1.07-3.43,4.71-4.5,4.71s-2.56-5.78-2.56-5.78C269.6,175.49,273.24,177,273.67,178.06Zm-14.56,3.21a7.87,7.87,0,0,1,3-3.64s2.35-.85,2.35.43,1.93,2.14,1.93,4.07-3,.21-5.14.85S258.26,183.63,259.11,181.27Zm2.36,10.06c-1.29-.43-3.21-4.06-2.78-4.92s6.2-1.07,6.2-1.07c1.07-.43,2.57,1.28,1.5,2.57S262.75,191.76,261.47,191.33Zm9.42,1.72c-1.29.42-4.5.42-4.93-.43s3-5.14,3-5.14,1.28-1.28,2.35-.21a13.13,13.13,0,0,1,2.79,3.42C274.53,191.76,272.17,192.62,270.89,193.05Zm5.78-4.71-3.86-3.21c-2.14-1.08,1.29-3.22,2.79-4.07s2.35-.86,3,2.35A4.93,4.93,0,0,1,276.67,188.34Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "240.61 246.62 249.53 293.08 240.61 352.21 325.08 352.21 313.82 314.66 315.69 283.22 325.08 246.62 240.61 246.62",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.69,274.31l-27.22,1.4,13.61-29.09s-17.36-8.45-42.23-8c-24.88-.47-42.24,8-42.24,8l13.61,29.09L227,274.31a120.61,120.61,0,0,0-1.23,18.31q.16,6.79,0,13.58A120.67,120.67,0,0,0,227,324.52l27.22-1.41-13.61,29.1s17.36,8.44,42.24,8c24.87.47,42.23-8,42.23-8l-13.61-29.1,27.22,1.41a120.67,120.67,0,0,0,1.23-18.32q-.17-6.78,0-13.58A120.61,120.61,0,0,0,338.69,274.31Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.18,279.63s-4.55,3.85-3.5,5.95,5.6-2.8,6.3-4.9S282.28,278.58,280.18,279.63Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.22,284.18s-4.54,3.85-3.49,5.95,5.59-2.8,6.29-4.9S290.32,283.13,288.22,284.18Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.82,292.93s-4.55,3.85-3.5,5.95,5.6-2.8,6.3-4.9S295.92,291.88,293.82,292.93Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.31,309s-4.54,3.85-3.49,6,5.59-2.8,6.29-4.9S313.41,308,311.31,309Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.51,275.33s-5.67-1.82-6.89.18,5.33,3.27,7.48,2.75S292.52,276.56,290.51,275.33Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.12,276.73s-5.67-1.82-6.9.18,5.34,3.27,7.49,2.75S277.12,278,275.12,276.73Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.67,292.13s-5.67-1.83-6.9.17,5.34,3.27,7.49,2.76S281.67,293.35,279.67,292.13Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305,284.53s-4.55,3.85-3.5,6,5.6-2.8,6.3-4.9S307.12,283.48,305,284.53Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.06,289.08s-4.54,3.85-3.49,5.95,5.59-2.8,6.29-4.9S315.16,288,313.06,289.08Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.74,289.18s-4.33-4.09-6.3-2.81,3.4,5.25,5.57,5.71S298,291.15,296.74,289.18Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.62,327.56s-4.33-4.09-6.3-2.81,3.41,5.25,5.57,5.71S297.9,329.53,296.62,327.56Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.67,296.08s-4.33-4.09-6.3-2.82,3.41,5.25,5.57,5.72S292,298.05,290.67,296.08Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.68,321.62s-4.33-4.1-6.3-2.82,3.4,5.25,5.57,5.71S278,323.59,276.68,321.62Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.66,297.83s-4.55,3.84-3.5,5.94,5.6-2.79,6.3-4.89S320.76,296.78,318.66,297.83Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.35,280.23s-5.67-1.83-6.89.17,5.33,3.28,7.48,2.76S317.35,281.46,315.35,280.23Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300,281.63s-5.67-1.83-6.9.17,5.34,3.28,7.49,2.76S302,282.86,300,281.63Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.51,297s-5.67-1.82-6.9.18,5.33,3.27,7.49,2.76S306.51,298.25,304.51,297Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.83,304.47s-4.54,3.85-3.49,5.95,5.59-2.8,6.29-4.9S267.93,303.42,265.83,304.47Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.88,309s-4.55,3.85-3.5,6,5.6-2.8,6.3-4.9S276,308,273.88,309Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.48,317.77s-4.55,3.85-3.5,6,5.6-2.8,6.3-4.9S281.58,316.72,279.48,317.77Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.72,271.59s-4.55,3.85-3.5,6,5.6-2.8,6.3-4.9S300.82,270.54,298.72,271.59Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.17,300.17s-5.67-1.82-6.9.18,5.34,3.27,7.49,2.75S278.17,301.4,276.17,300.17Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.78,301.57s-5.67-1.83-6.9.17,5.33,3.28,7.49,2.76S262.78,302.8,260.78,301.57Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.33,317s-5.67-1.83-6.9.17,5.33,3.27,7.48,2.76S267.33,318.19,265.33,317Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.69,288.38s-4.55,3.85-3.5,5.95,5.6-2.8,6.29-4.9S264.79,287.33,262.69,288.38Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.73,292.93s-4.55,3.85-3.5,5.95,5.6-2.8,6.3-4.9S272.83,291.88,270.73,292.93Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.33,301.67s-4.55,3.85-3.5,5.95,5.6-2.8,6.3-4.9S278.43,300.63,276.33,301.67Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273,284.08s-5.67-1.83-6.9.17,5.34,3.28,7.49,2.76S275,285.31,273,284.08Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.63,285.48s-5.67-1.83-6.9.17,5.34,3.28,7.49,2.76S259.63,286.71,257.63,285.48Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.18,300.87s-5.67-1.82-6.9.18,5.33,3.27,7.49,2.75S264.18,302.1,262.18,300.87Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.87,271.14s-4.54,3.84-3.49,5.94,5.59-2.8,6.29-4.89S272,270.09,269.87,271.14Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.92,275.68s-4.55,3.85-3.5,5.95,5.6-2.8,6.3-4.9S280,274.63,277.92,275.68Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.52,284.43s-4.55,3.85-3.5,5.95,5.6-2.8,6.3-4.9S285.62,283.38,283.52,284.43Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.21,266.84s-5.67-1.83-6.9.17,5.34,3.27,7.49,2.76S282.21,268.06,280.21,266.84Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.82,268.24s-5.67-1.83-6.9.17,5.33,3.27,7.49,2.76S266.82,269.46,264.82,268.24Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.37,283.63s-5.67-1.83-6.9.17,5.33,3.27,7.48,2.76S271.37,284.86,269.37,283.63Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.69,317.56s3.74-4.64,2.31-6.51-5,3.81-5.26,6S297.82,319,299.69,317.56Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.93,314.61s3.74-4.64,2.31-6.5-5,3.8-5.26,6S289.06,316,290.93,314.61Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.17,306.2s4.66-4.34,3.09-5.91-6.05,3.66-6.52,5.63S281.9,307.57,284.17,306.2Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265,340.1s5.95.22,6.59-2-6-1.7-7.95-.61S262.73,339.47,265,340.1Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.1,331.33s5.95.21,6.58-2.05-6-1.7-7.95-.61S259.84,330.69,262.1,331.33Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.84,321.09s6,.21,6.59-2-6-1.69-8-.61S261.58,320.45,263.84,321.09Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.77,331.2s3,5.17,5.22,4.51-1.75-6-3.68-7.07S273.12,329,273.77,331.2Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.16,321.9s.45,5.94,2.77,6.32,1-6.17-.28-8S259.54,319.59,259.16,321.9Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.28,320.88s.46,5.94,2.77,6.32,1-6.18-.28-8S268.66,318.56,268.28,320.88Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.77,327.6s3,5.17,5.22,4.51-1.74-6-3.68-7.07S281.12,325.35,281.77,327.6Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.92,336.62s6,.21,6.59-2.05-6-1.69-7.95-.61S278.66,336,280.92,336.62Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.66,326.38s6,.21,6.59-2-6-1.7-7.95-.62S280.4,325.75,282.66,326.38Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.28,341.63s3,5.16,5.22,4.51-1.75-6-3.69-7.08S272.62,339.37,273.28,341.63Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.75,334.31s5.95.21,6.58-2.05-6-1.69-7.95-.61S263.49,333.67,265.75,334.31Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.68,344.42s3,5.17,5.22,4.51-1.75-6-3.69-7.07S275,342.17,275.68,344.42Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.9,317.76s-6.36.08-6.26,2.3,6.95,1.36,8.61.21S282.51,318.27,279.9,317.76Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.64,314.46s6,.21,6.59-2-6-1.69-8-.61S272.38,313.82,274.64,314.46Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.75,305.68s5.95.21,6.59-2.05-6-1.69-8-.61S269.49,305.05,271.75,305.68Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.49,295.45s5.95.21,6.59-2.05-6-1.7-8-.61S271.23,294.81,273.49,295.45Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.42,305.56s3,5.16,5.22,4.51-1.74-6-3.68-7.08S282.77,303.3,283.42,305.56Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.81,296.26s.45,5.94,2.77,6.32,1-6.18-.28-8S269.19,293.94,268.81,296.26Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.93,295.23s.46,5.94,2.77,6.32,1-6.17-.27-8S278.31,292.92,277.93,295.23Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.42,302s3,5.16,5.22,4.51-1.74-6-3.68-7.08S290.77,299.7,291.42,302Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.57,311s6,.21,6.59-2.05-6-1.7-8-.61S288.31,310.34,290.57,311Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.31,300.74s6,.21,6.59-2.05-6-1.69-7.95-.61S290.05,300.1,292.31,300.74Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.93,316s3,5.17,5.22,4.52-1.75-6-3.69-7.08S282.27,313.73,282.93,316Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.4,308.66s6,.22,6.59-2-6-1.7-8-.61S273.14,308,275.4,308.66Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.33,318.78s3,5.16,5.22,4.51-1.75-6-3.68-7.08S284.68,316.52,285.33,318.78Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.56,292.12s-6.37.07-6.26,2.3,6.94,1.35,8.61.21S292.16,292.62,289.56,292.12Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.44,319.42s5.95.21,6.59-2-6-1.7-8-.62S262.18,318.79,264.44,319.42Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.54,310.65s6,.21,6.59-2-6-1.7-7.95-.61S259.28,310,261.54,310.65Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.28,300.41s6,.21,6.59-2.05-6-1.69-7.95-.61S261,299.77,263.28,300.41Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.22,310.52s3,5.17,5.22,4.51-1.75-6-3.69-7.07S272.56,308.27,273.22,310.52Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.61,301.22s.45,5.94,2.76,6.32,1-6.18-.27-8S259,298.9,258.61,301.22Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.73,300.2s.46,5.94,2.77,6.32,1-6.18-.28-8S268.11,297.88,267.73,300.2Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.22,306.92s3,5.17,5.22,4.51-1.75-6-3.68-7.07S280.56,304.67,281.22,306.92Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.37,315.94s5.95.21,6.59-2.05-6-1.69-7.95-.61S278.11,315.3,280.37,315.94Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.11,305.7s6,.21,6.59-2.05-6-1.69-7.95-.61S279.85,305.07,282.11,305.7Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.72,321s3,5.16,5.22,4.51-1.74-6-3.68-7.08S272.07,318.69,272.72,321Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.19,313.63s6,.21,6.59-2.05-6-1.69-7.95-.61S262.93,313,265.19,313.63Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.13,323.74s3,5.17,5.22,4.51-1.75-6-3.69-7.07S274.47,321.49,275.13,323.74Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.35,297.08s-6.36.08-6.26,2.3,6.94,1.36,8.61.21S282,297.59,279.35,297.08Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.85,301.27s6,.21,6.59-2-6-1.7-7.95-.61S266.59,300.63,268.85,301.27Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266,292.49s6,.21,6.59-2.05-6-1.69-8-.61S263.7,291.85,266,292.49Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.7,282.25s5.95.21,6.59-2.05-6-1.69-8-.61S265.44,281.62,267.7,282.25Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.63,292.36s3,5.17,5.22,4.52-1.74-6-3.68-7.08S277,290.11,277.63,292.36Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263,283.06s.45,5.94,2.77,6.32,1-6.17-.28-8S263.4,280.75,263,283.06Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.15,282s.45,5.94,2.77,6.32,1-6.18-.28-8S272.53,279.72,272.15,282Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.63,288.76s3,5.17,5.22,4.52-1.74-6-3.68-7.08S285,286.51,285.63,288.76Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.78,297.78s6,.21,6.59-2-6-1.69-7.95-.61S282.53,297.15,284.78,297.78Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.53,287.55s6,.21,6.58-2.05-6-1.7-7.95-.61S284.27,286.91,286.53,287.55Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.14,302.79s3,5.17,5.22,4.51-1.75-6-3.68-7.07S276.48,300.54,277.14,302.79Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.61,295.47s5.95.21,6.59-2.05-6-1.69-8-.61S267.35,294.84,269.61,295.47Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.54,305.58s3,5.17,5.22,4.52-1.74-6-3.68-7.08S278.89,303.33,279.54,305.58Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.77,278.92s-6.36.08-6.26,2.3,6.94,1.36,8.61.22S286.37,279.43,283.77,278.92Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.78,289.87s6,.21,6.59-2.05-6-1.69-8-.61S268.52,289.23,270.78,289.87Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.88,281.09s6,.21,6.59-2-6-1.69-8-.61S265.62,280.46,267.88,281.09Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.62,270.85s6,.22,6.59-2-6-1.7-7.95-.62S267.36,270.22,269.62,270.85Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.56,281s3,5.16,5.22,4.51-1.75-6-3.69-7.08S278.9,278.71,279.56,281Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.94,271.67s.46,5.94,2.77,6.32,1-6.18-.27-8S265.32,269.35,264.94,271.67Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.07,270.64s.45,5.94,2.77,6.32,1-6.17-.28-8S274.45,268.33,274.07,270.64Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.56,277.37s3,5.16,5.22,4.51-1.75-6-3.69-7.08S286.9,275.11,287.56,277.37Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.71,286.38s6,.22,6.59-2-6-1.7-7.95-.61S284.45,285.75,286.71,286.38Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.45,276.15s6,.21,6.59-2-6-1.69-8-.61S286.19,275.51,288.45,276.15Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.06,291.39s3,5.17,5.22,4.51-1.74-6-3.68-7.07S278.41,289.14,279.06,291.39Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.53,284.07s6,.21,6.59-2-6-1.7-7.95-.62S269.27,283.44,271.53,284.07Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.47,294.19s3,5.16,5.22,4.51-1.75-6-3.69-7.08S280.81,291.93,281.47,294.19Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.69,267.52s-6.36.08-6.26,2.31,6.94,1.35,8.61.21S288.3,268,285.69,267.52Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.35,323.73s5.91.72,6.74-1.47-5.86-2.21-7.87-1.3S288.15,322.9,290.35,323.73Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.2,319.45s5.91.72,6.74-1.47-5.85-2.21-7.87-1.3S303,318.62,305.2,319.45Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.31,291.88s5.91.72,6.74-1.47-5.85-2.21-7.87-1.3S316.12,291.05,318.31,291.88Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.83,305.19s5.91.73,6.74-1.47-5.86-2.21-7.87-1.3S295.63,304.36,297.83,305.19Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.39,338.78s5.92.72,6.75-1.47-5.86-2.21-7.88-1.3S258.2,338,260.39,338.78Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.79,340.65s3.74-4.64,2.32-6.51-5,3.81-5.26,6S278.93,342.07,280.79,340.65Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272,337.7s3.74-4.64,2.32-6.5-5,3.8-5.26,6S270.17,339.12,272,337.7Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.89,330.16s3.74-4.63,2.31-6.5-5,3.81-5.26,6S263,331.59,264.89,330.16Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.45,346.82s5.92.72,6.75-1.47-5.86-2.21-7.88-1.3S269.26,346,271.45,346.82Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.31,342.54s5.91.72,6.74-1.47-5.86-2.21-7.87-1.3S284.11,341.71,286.31,342.54Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.94,328.28s5.91.73,6.74-1.47-5.86-2.21-7.87-1.3S276.74,327.45,278.94,328.28Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.25,305.66s3.74-4.64,2.32-6.5-5,3.8-5.26,6S260.39,307.09,262.25,305.66Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.49,302.71s3.74-4.63,2.32-6.5-5,3.81-5.26,6S251.63,304.14,253.49,302.71Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.35,295.18s3.74-4.64,2.31-6.5-5,3.8-5.26,6S244.48,296.61,246.35,295.18Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.91,311.83s5.92.73,6.74-1.47-5.85-2.2-7.87-1.29S250.72,311,252.91,311.83Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.77,307.56s5.91.72,6.74-1.48-5.86-2.2-7.87-1.29S265.57,306.73,267.77,307.56Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.39,293.3s5.92.72,6.75-1.47-5.86-2.21-7.88-1.3S258.2,292.47,260.39,293.3Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.12,264.24s-5.25-5.25-9.45-3.15-6.64,2.45-10.14.7-6.78-1.71-7,1.75,2.42,4.4,4.55,3.85,2.1,1.75,2.1,4.55.58,4.34,3.44,3.57,6.31-3.11,6.89-.18,3.31,4.65,4.71,2.21,5.95-7.35,6.3-4.9,3.5,1.75,4.9-1.75,3.84-7.35.35-7.7A14.73,14.73,0,0,0,300.12,264.24Z",
    style: {
      fill: "#F09400",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.17,271.24a7.58,7.58,0,0,1-1.4,4.9c-1.67,2.12-1.52,4,.29,5.66s5.2,7.48,3.68,7.38-2.92,3.75-2.92,3.75l2.8,1.05s-2.8,2.45-1.4,4.55,5.41,4.3,7.35,1.4,1.43.14,1.94-2.91,5.41,2.56,5.06-2-4.2-6.3-3.85-7.35.35.7,2.1-2.1,3-4.76.64-5.18-2.39-.42-1-2.51,3.14-3.15.35-4.2-.7.35-1.4-2.8,0-4.55-3.15-3.85-3.15,3.5-5.6,1.75S293.12,264.94,294.17,271.24Z",
    style: {
      fill: "#F09400",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.47,282.08a7.58,7.58,0,0,1-1.4,4.9c-1.67,2.13-1.52,4,.29,5.67s5.19,7.48,3.67,7.38-2.91,3.74-2.91,3.74l2.8,1.05s-2.8,2.45-1.4,4.55,5.4,4.3,7.34,1.4,1.43.15,1.94-2.9,5.41,2.55,5.06-2-4.2-6.29-3.85-7.34.35.7,2.1-2.1,3-4.76.64-5.18-2.39-.42-1-2.52,3.15-3.15.35-4.2-.7.35-1.4-2.8,0-4.54-3.15-3.84-3.15,3.49-5.6,1.74S306.42,275.79,307.47,282.08Z",
    style: {
      fill: "#F09400",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.64,322.21a7.59,7.59,0,0,1,2.45-4.47c2.1-1.7,2.37-3.55,1-5.59s-3.4-8.44-1.95-8,3.68-3,3.68-3l-2.5-1.65s3.28-1.77,2.38-4.12-4.32-5.39-6.86-3-1.36-.46-2.53,2.4-4.71-3.68-5.38.83,2.7,7.07,2.13,8-.19-.76-2.51,1.58-4,4-1.78,4.9,2.24.94.41,2.68-3.77,2.37-1.27,4,.76-.19.74,3-1,4.43,2.22,4.45,3.85-2.72,5.85-.47S306.27,328.58,306.64,322.21Z",
    style: {
      fill: "#F09400",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.84,324.29s-.22,7.12-2.32,10.62-7,3.5-6.3,4.9,3.36.42,4.83,1.26,2.17,2.59,3.92.49,1.75-3.5,3.85-2.45,3.5-1.05,3.5-2.8,1.4,0,4.2-1.4,1.74-1.05,1.74-3.5,3-2.19,2.1-5.25-3.84,0-5.94.35-.47-.13-3.73-2.69S297.06,321,296.84,324.29Z",
    style: {
      fill: "#F09400",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.17,315.46s-7.05,1.05-10.86-.4-4.69-6.26-5.94-5.32.18,3.37-.39,5-2.16,2.6.22,3.94,3.75,1.1,3.09,3.36,1.66,3.25,3.38,2.94.25,1.38,2.12,3.89,1.35,1.53,3.76,1.1,2.69,2.55,5.53,1.13-.68-3.79-1.4-5.79.06-.48,2-4.15S296.44,315.09,293.17,315.46Z",
    style: {
      fill: "#F09400",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.06,316.82a.9.9,0,0,1-.85-.6,3.64,3.64,0,0,1,0-3c.74-1.34,2.39-1.75,4.14-2.18a8.46,8.46,0,0,0,3.9-1.64,1.15,1.15,0,0,0,.44-1c-.34-2-5.7-4.55-7.72-5.52-2.22-1.07-3.72-3.84-4-7.39-.32-4.12,1.13-7.93,3.7-9.71,2.35-1.61,5.61-2.48,8.76-3.31,3.31-.87,6.44-1.7,7.56-3.19.78-1.05-1.44-4-3.22-6.33-2.57-3.39-5.22-6.89-3.09-9.13,3.27-3.45,14.58-3.55,15.86-3.55a.9.9,0,1,1,0,1.79c-3.26,0-12.23.54-14.56,3-1.08,1.14,1.3,4.29,3.22,6.82,2.48,3.27,4.82,6.36,3.22,8.48s-4.91,2.9-8.53,3.86c-3,.79-6.11,1.61-8.2,3s-3.2,4.59-2.93,8.09c.22,2.87,1.36,5.13,3,5.91,4.94,2.37,8.31,4.45,8.72,6.84a2.91,2.91,0,0,1-.94,2.62,9.8,9.8,0,0,1-4.74,2.11c-1.36.34-2.64.65-3,1.3a2,2,0,0,0,.09,1.55.9.9,0,0,1-.56,1.14A1,1,0,0,1,248.06,316.82Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.13,316.49a.93.93,0,0,1-.46-.12c-.91-.55-1.74-1.18-1.7-2.08s.91-1.33,1.82-1.77c1.41-.67,2.33-1.2,2.23-2.41a2.7,2.7,0,0,0-.11-.64c-.15,0-.38.1-.56.15-1.31.38-3.74,1.1-6.61-1.91-1.11-1.17-1.53-2.21-1.28-3.18.42-1.61,2.5-2.25,4.33-2.82a11.39,11.39,0,0,0,1.93-.7c-.53-.51-2-.51-3.35-.51-2.09,0-4.51,0-5.53-1.81-1.25-2.22.73-3.5,2.65-4.73a16,16,0,0,0,4.29-3.61c1.1-1.45.73-2.08.17-3-.87-1.52-1.42-3.08,1.44-5.45,3.1-2.56,6.64-1.28,9.48-.25,1.8.66,3.36,1.22,4.08.59,2.14-1.87,4.25-4.51,3.78-6.35-.38-1.53-2.59-2.33-4.37-2.74-3.77-.86-5.87-2.32-6.25-4.33-.58-3.09,3.07-6.08,5.3-7.59a28,28,0,0,0,3-2.26.89.89,0,0,1,.77-.83,1,1,0,0,1,1.08.61c.3.76,0,1.3-3.89,4-3.07,2.09-4.82,4.3-4.54,5.77.23,1.24,1.93,2.25,4.89,2.92,3.3.76,5.23,2.12,5.71,4.05.81,3.21-2.76,6.76-4.33,8.14s-3.65.56-5.89-.25c-2.66-1-5.41-2-7.71-.06-1.94,1.6-1.63,2.12-1,3.17a3.91,3.91,0,0,1-.3,5,17.44,17.44,0,0,1-4.75,4c-2.23,1.45-2.39,1.76-2.06,2.35.51.9,2.27.9,4,.9,2,0,4.14,0,5,1.55a1.5,1.5,0,0,1,.12,1.34c-.37,1-1.62,1.34-3.2,1.83-1.17.36-2.95.91-3.12,1.55-.08.3.23.86.83,1.49,2.12,2.22,3.62,1.78,4.82,1.43a2.33,2.33,0,0,1,2.09,0,2.6,2.6,0,0,1,.86,2c.22,2.54-1.94,3.57-3.24,4.18l-.57.29a6.75,6.75,0,0,0,.6.4.89.89,0,0,1-.46,1.66Zm15.34-56.62Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.11,320.58a.9.9,0,0,1-.9-.89,1.78,1.78,0,0,1,.89-1.34,5.58,5.58,0,0,0,2.24-3.76c.37-1.78.16-2.2-.22-3a9.57,9.57,0,0,1-1.1-4.32c-.22-3.31,1.2-4.26,2.35-5a2.48,2.48,0,0,0,1.42-1.87c.14-.94-.53-1.39-2-2.13-.94-.48-1.92-1-2.22-1.92a2.11,2.11,0,0,1,.21-1.64c1-1.78,2.83-1.88,4.49-2a6.62,6.62,0,0,0,3.49-.8c.76-.53.78-1,.74-2.28a7.74,7.74,0,0,1,1.93-6,7.58,7.58,0,0,1,3.64-2.76c.66-.24.93-.33,1.51-2.38.71-2.48-.54-3.33-3.43-5a28.71,28.71,0,0,1-3.63-2.38c-1.07-.86-1.51-1.73-1.31-2.6.4-1.79,3.33-2.47,6.43-3.19a23.32,23.32,0,0,0,2.94-.8.89.89,0,1,1,.71,1.64,21.32,21.32,0,0,1-3.25.91c-1.35.31-4.94,1.15-5.08,1.84,0,0,0,.26.68.8a26.88,26.88,0,0,0,3.42,2.23c2.76,1.61,5.37,3.13,4.25,7.06-.76,2.66-1.39,3.13-2.63,3.58a5.89,5.89,0,0,0-2.88,2.22,6,6,0,0,0-1.51,4.77c.05,1.28.1,2.72-1.52,3.83a8.22,8.22,0,0,1-4.41,1.12c-1.61.08-2.54.17-3,1a.48.48,0,0,0-.09.25c.07.23.86.62,1.32.86,1.32.66,3.3,1.67,2.95,4a4.19,4.19,0,0,1-2.19,3.09c-1,.66-1.71,1.15-1.56,3.42a8,8,0,0,0,.91,3.63c.55,1.08.84,1.9.38,4.14a7.29,7.29,0,0,1-2.89,4.8L255,320A.9.9,0,0,1,254.11,320.58Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.91,310.93a.78.78,0,0,1-.26,0,.9.9,0,0,1-.6-1.12c.14-.46-.37-.86-1.64-1.65a5.5,5.5,0,0,1-2.6-2.55c-.6-1.79.32-2.83,1.49-4.15a24.49,24.49,0,0,0,1.89-2.36,1.75,1.75,0,0,0,.41-1c-.07-.33-.63-.71-1.23-1.11a6.43,6.43,0,0,1-2.71-2.91c-.91-2.33,1.83-3.4,4.24-4.35,2-.8,4.37-1.7,4.92-3.16.36-1-.48-1.64-2.62-2.84-1.43-.8-2.91-1.63-3.26-3a2.57,2.57,0,0,1,.39-2,5.89,5.89,0,0,1,4.23-2.8c1.09-.25,1.58-.39,1.93-1.18s-1.16-2.53-2.51-4c-1.56-1.7-3.18-3.46-3.45-5.33-.58-4.05,5.18-6.72,5.43-6.83a.88.88,0,0,1,1.18.44.9.9,0,0,1-.44,1.19c-1.33.61-4.71,2.68-4.39,4.95.19,1.32,1.68,2.94,3,4.37,1.89,2.05,3.68,4,2.83,5.93a3.83,3.83,0,0,1-3.17,2.21,4.14,4.14,0,0,0-3.1,2c-.25.39-.2.59-.18.65.15.6,1.34,1.26,2.39,1.85,1.85,1,4.39,2.46,3.43,5-.83,2.22-3.55,3.28-5.94,4.21-2,.78-3.47,1.41-3.23,2a4.9,4.9,0,0,0,2,2.07,3.86,3.86,0,0,1,2,2.27,3.16,3.16,0,0,1-.69,2.38,24.85,24.85,0,0,1-2,2.54c-1.17,1.33-1.38,1.65-1.13,2.4.18.55,1.07,1.1,1.85,1.58,1.25.78,3,1.85,2.41,3.71A.91.91,0,0,1,255.91,310.93Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.18,319.76a.9.9,0,0,1-.42-.1.91.91,0,0,1-.37-1.22c1.2-2.23-.1-3.32-2.23-4.73a5.37,5.37,0,0,1-1.66-1.4c-1.1-1.75.28-7.92,1.43-10.2.25-.52,0-.84-1.9-2a11.62,11.62,0,0,1-3.05-2.29,2.44,2.44,0,0,1-.78-2.22c.31-1,1.44-1.3,2.89-1.68a21.73,21.73,0,0,0,2.49-.78,3.61,3.61,0,0,0,2.2-1.8,3.21,3.21,0,0,0-.37-2.56c-1.11-2.26,1.65-5,5.14-8.43.83-.82,1.69-1.67,2.53-2.55a2.54,2.54,0,0,0,.94-1.71c0-.72-1-1.48-2-2.29-1.45-1.15-3.1-2.46-3.42-4.56-.78-5.07,8.36-6.68,8.75-6.75a.9.9,0,0,1,.3,1.77c-2,.34-7.7,1.95-7.28,4.7.22,1.42,1.51,2.44,2.76,3.44s2.59,2.05,2.69,3.57a4.1,4.1,0,0,1-1.44,3.08c-.85.89-1.72,1.75-2.56,2.57-2.5,2.47-5.33,5.27-4.79,6.36a4.89,4.89,0,0,1,.44,4,5.26,5.26,0,0,1-3.22,2.82,22.42,22.42,0,0,1-2.69.85,10.67,10.67,0,0,0-1.58.5,3,3,0,0,0,.37.51,10.09,10.09,0,0,0,2.6,1.9c1.64,1,3.67,2.15,2.59,4.32-1.18,2.36-2,7.64-1.51,8.45a6.16,6.16,0,0,0,1.13.86c1.71,1.13,4.89,3.23,2.82,7.07A.89.89,0,0,1,259.18,319.76Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.2,300.62a.89.89,0,0,1-.66-.29,7.68,7.68,0,0,1-.44-8.9c1.47-2.58,3.76-3.22,5.6-3.73s2.84-.84,3-2.34c.07-.55.13-1,.18-1.46.38-3.09.55-3.79,3.17-5.1,1.63-.82,4-3.93,4.58-6.06a1.66,1.66,0,0,0,.08-1c-.17-.18-.48-.43-.83-.72-1.85-1.53-5.71-4.7-2.18-9.34a18.75,18.75,0,0,1,3.79-3.83c1.07-.84,1.24-1,1.11-2.25a.88.88,0,0,1,.79-1,.89.89,0,0,1,1,.8c.23,2.15-.49,2.83-1.79,3.84a17.18,17.18,0,0,0-3.46,3.5c-2.3,3-.5,4.9,1.89,6.87a12.39,12.39,0,0,1,1,.88,2.37,2.37,0,0,1,.46,2.14c-.46,2.61-3.35,6.57-5.63,7.71-1.84.93-1.84.93-2.18,3.72-.06.43-.12.92-.19,1.48-.37,2.74-2.48,3.32-4.34,3.83-1.68.47-3.42.95-4.53,2.89a5.86,5.86,0,0,0,.22,6.81.89.89,0,0,1-.07,1.26A.87.87,0,0,1,249.2,300.62Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.44,317.64a.91.91,0,0,1-.75-.4c-1.79-2.69.4-5,1.58-6.25.17-.17.37-.39.5-.54a6.38,6.38,0,0,0-1.15-.64l-.58-.28a2.48,2.48,0,0,1-1.28-1.49c-.35-1.1,0-2.6.89-4.32a.79.79,0,0,0,.12-.31,5.54,5.54,0,0,0-.64-.51,9.3,9.3,0,0,1-3.63-4.84c-1.93-5.46,2.21-13.32,6.72-15.2,2.93-1.22,2.93-1.26,2.9-2.44,0-.2,0-.41,0-.65,0-1.68,1.88-2.61,3.88-3.6,1.43-.7,3-1.49,3.61-2.43.32-.53.35-.59-1-1.64a14,14,0,0,1-4.28-5c-2.38-4.75.91-8.2,3-9.37a.9.9,0,0,1,.88,1.57c-.2.11-4.45,2.61-2.26,7a12.32,12.32,0,0,0,3.79,4.42c1.21.95,2.58,2,1.41,4-.83,1.39-2.62,2.27-4.34,3.12-1.15.57-2.89,1.42-2.89,2,0,.22,0,.42,0,.6.06,2.16-.42,2.66-4,4.15-3.38,1.41-7.4,8.2-5.71,12.94a7.47,7.47,0,0,0,3,4c.82.6,1.95,1.43,1,3.12a4.51,4.51,0,0,0-.76,2.92.69.69,0,0,0,.37.43l.55.27c1.15.55,2.24,1.07,2.24,2.33,0,.6-.42,1-1.06,1.71-1.3,1.37-2.31,2.62-1.38,4a.91.91,0,0,1-.25,1.25A.94.94,0,0,1,245.44,317.64Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.37,313.05c-.6,0-1-.67-1.27-1.07a.87.87,0,0,1,0-1c-.28-.7-.76-1.8-1.55-3.54a62.89,62.89,0,0,0-3.25-6c-2.6-4.37-4.85-8.14-2-11.5,3.71-4.42,6.72-4.77,10.38-3.9l.52.12c2.87.69,3.11.75,7.24-.28,4.95-1.24,5.83-2.88,6-4.33,0-.31.1-.6.15-.88.3-1.6.43-2.26-2.87-3.56-4.78-1.87-6-3.28-7.27-5.06-1.64-2.34-4-6.68-1.4-9.47s8.74-3.6,9.83-3.38c.62.13,2.84.27,3.64.31a.9.9,0,0,1,.84.95.88.88,0,0,1-.94.84c-.31,0-3-.17-3.89-.34s-6.21.75-8.17,2.84c-1.8,1.94.49,5.69,1.56,7.22s2.14,2.73,6.46,4.42,4.4,3.31,4,5.56c-.05.26-.1.52-.14.81-.41,2.84-2.68,4.64-7.38,5.81-4.4,1.1-4.9,1.05-8.09.29l-.51-.12c-3.22-.77-5.43-.47-8.6,3.3-1.91,2.28-.56,4.8,2.19,9.43a64,64,0,0,1,3.34,6.15c2.45,5.36,2.49,5.74,1.62,6.21A1,1,0,0,1,250.37,313.05Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.31,253.34l59.26,112.28,4.68-2.35L228.14,252.34a1,1,0,0,0-1.25-.47h0A1,1,0,0,0,226.31,253.34Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231,251.19l66.27,108.28,4.52-2.63-69-106.76a1,1,0,0,0-1.28-.4h0A1,1,0,0,0,231,251.19Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.5,
    y: 210.66,
    width: 143.17,
    height: 20.26,
    style: {
      fill: "#F09400"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.5,
    y: 363.96,
    width: 143.17,
    height: 20.26,
    style: {
      fill: "#F09400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 215.64,
    y1: 218.48,
    x2: 257.54,
    y2: 218.48,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 215.64,
    y1: 223.55,
    x2: 272.73,
    y2: 223.55,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.53,226.08v-1a2.22,2.22,0,0,1-1.72-.74,3.37,3.37,0,0,1-.62-2.07l1.58-.26a3.9,3.9,0,0,0,.12.93,1.09,1.09,0,0,0,.28.56.69.69,0,0,0,.49.18.51.51,0,0,0,.48-.22,1.08,1.08,0,0,0,.13-.52,1.61,1.61,0,0,0-.27-1,3.65,3.65,0,0,0-.72-.78l-.95-.81a6.67,6.67,0,0,1-.58-.62,2.63,2.63,0,0,1-.41-.71,2.75,2.75,0,0,1-.15-.95,2.19,2.19,0,0,1,.6-1.64,2.52,2.52,0,0,1,1.6-.67v-1h.54v1a2.18,2.18,0,0,1,1,.28,1.69,1.69,0,0,1,.59.6,3,3,0,0,1,.29.79,6.46,6.46,0,0,1,.11.84l-1.6.23a5,5,0,0,0-.07-.73,1,1,0,0,0-.2-.5.51.51,0,0,0-.44-.17.58.58,0,0,0-.48.25.9.9,0,0,0-.16.53,1.31,1.31,0,0,0,.24.82,6.31,6.31,0,0,0,.56.61l.93.8a6.68,6.68,0,0,1,.68.73,3.55,3.55,0,0,1,.51.86,3.07,3.07,0,0,1,.19,1.09,2.38,2.38,0,0,1-.24,1.08,2,2,0,0,1-.7.79,2.31,2.31,0,0,1-1.06.36v1.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.79,224.93v-1.22l2.2-3.39c.17-.25.32-.49.47-.72a5.26,5.26,0,0,0,.36-.71,2.25,2.25,0,0,0,.14-.78,1.16,1.16,0,0,0-.17-.67.55.55,0,0,0-.48-.22.7.7,0,0,0-.52.18.91.91,0,0,0-.24.49,2.73,2.73,0,0,0-.07.66V219h-1.69v-.45a4,4,0,0,1,.25-1.43,2.14,2.14,0,0,1,.8-1,2.6,2.6,0,0,1,1.42-.35,2.37,2.37,0,0,1,1.8.63,2.43,2.43,0,0,1,.61,1.75,2.93,2.93,0,0,1-.17,1,4.68,4.68,0,0,1-.44.9l-.59.89-1.74,2.62h2.69v1.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.81,225.08a2.58,2.58,0,0,1-1.46-.34,1.75,1.75,0,0,1-.68-1,5,5,0,0,1-.19-1.47h1.67a4.87,4.87,0,0,0,.06.83.93.93,0,0,0,.22.5.62.62,0,0,0,.49.16.55.55,0,0,0,.47-.25,1.69,1.69,0,0,0,.18-.67c0-.29,0-.63,0-1a5.39,5.39,0,0,0-.06-.85,1.28,1.28,0,0,0-.21-.58.6.6,0,0,0-.5-.21.66.66,0,0,0-.5.21,1.33,1.33,0,0,0-.28.61h-1.48l.12-5.15h4.16v1.49h-2.74l-.1,2a1,1,0,0,1,.46-.29,2.17,2.17,0,0,1,.68-.14,1.66,1.66,0,0,1,1.17.26,2,2,0,0,1,.69,1,5,5,0,0,1,.22,1.6,9.13,9.13,0,0,1-.09,1.32,2.89,2.89,0,0,1-.34,1.05,1.9,1.9,0,0,1-.74.69A2.81,2.81,0,0,1,331.81,225.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.13,224.93v-1.65h1.61v1.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.24,225.08a2.56,2.56,0,0,1-1.36-.33,2.1,2.1,0,0,1-.8-.92,3.24,3.24,0,0,1-.27-1.36v-4.06a3.35,3.35,0,0,1,.26-1.39,2,2,0,0,1,.79-.93,2.52,2.52,0,0,1,1.38-.34,2.41,2.41,0,0,1,1.35.34,2,2,0,0,1,.79.93,3.52,3.52,0,0,1,.26,1.39v4.06a3.24,3.24,0,0,1-.27,1.36,2.12,2.12,0,0,1-.81.92A2.46,2.46,0,0,1,340.24,225.08Zm0-1.52a.48.48,0,0,0,.43-.19,1,1,0,0,0,.18-.45,2.82,2.82,0,0,0,0-.48v-4a4.63,4.63,0,0,0,0-.51,1.11,1.11,0,0,0-.18-.46.5.5,0,0,0-.44-.2.53.53,0,0,0-.46.2,1.11,1.11,0,0,0-.18.46,4.75,4.75,0,0,0,0,.51v4a2.9,2.9,0,0,0,.05.48.92.92,0,0,0,.19.45A.51.51,0,0,0,340.24,223.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.3,225.08a2.55,2.55,0,0,1-1.35-.33,2.1,2.1,0,0,1-.8-.92,3.24,3.24,0,0,1-.27-1.36v-4.06a3.35,3.35,0,0,1,.26-1.39,2,2,0,0,1,.79-.93,2.49,2.49,0,0,1,1.37-.34,2.43,2.43,0,0,1,1.36.34,2,2,0,0,1,.79.93,3.52,3.52,0,0,1,.26,1.39v4.06a3.24,3.24,0,0,1-.27,1.36,2.12,2.12,0,0,1-.81.92A2.47,2.47,0,0,1,346.3,225.08Zm0-1.52a.49.49,0,0,0,.44-.19,1,1,0,0,0,.18-.45,2.82,2.82,0,0,0,0-.48v-4a3.08,3.08,0,0,0,0-.51,1,1,0,0,0-.17-.46.61.61,0,0,0-.9,0,1.11,1.11,0,0,0-.18.46,4.75,4.75,0,0,0,0,.51v4a2.9,2.9,0,0,0,.05.48.92.92,0,0,0,.19.45A.49.49,0,0,0,346.3,223.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 215.64,
    y1: 372.7,
    x2: 257.54,
    y2: 372.7,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 215.64,
    y1: 377.77,
    x2: 272.73,
    y2: 377.77,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.3,380.49v-1a2.22,2.22,0,0,1-1.72-.74,3.36,3.36,0,0,1-.62-2.06l1.58-.27a3.9,3.9,0,0,0,.12.93,1.18,1.18,0,0,0,.28.56.69.69,0,0,0,.49.18.51.51,0,0,0,.48-.22,1.07,1.07,0,0,0,.13-.51,1.65,1.65,0,0,0-.27-1,3.65,3.65,0,0,0-.72-.78l-.95-.81a6.67,6.67,0,0,1-.58-.62,2.44,2.44,0,0,1-.56-1.66,2.19,2.19,0,0,1,.6-1.64,2.55,2.55,0,0,1,1.61-.67v-1h.53v1a2.18,2.18,0,0,1,1,.28,1.69,1.69,0,0,1,.59.6,3,3,0,0,1,.29.79,5.1,5.1,0,0,1,.11.84l-1.6.23a5,5,0,0,0-.07-.73,1,1,0,0,0-.2-.5.48.48,0,0,0-.44-.16.55.55,0,0,0-.48.24.9.9,0,0,0-.16.53,1.24,1.24,0,0,0,.25.82,6.18,6.18,0,0,0,.55.61l.93.8a5.83,5.83,0,0,1,.68.73,3.55,3.55,0,0,1,.51.86,3.13,3.13,0,0,1,.19,1.1,2.37,2.37,0,0,1-.24,1.07,1.91,1.91,0,0,1-.7.79,2.27,2.27,0,0,1-1.06.36v1.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326,379.5a2.6,2.6,0,0,1-1.44-.35,1.9,1.9,0,0,1-.77-1,4.15,4.15,0,0,1-.23-1.42v-.33h1.72v.31a4.38,4.38,0,0,0,.07.72.84.84,0,0,0,.22.43.69.69,0,0,0,.45.14.61.61,0,0,0,.45-.15,1,1,0,0,0,.2-.44,4.67,4.67,0,0,0,.05-.72,2.18,2.18,0,0,0-.2-1.05.84.84,0,0,0-.8-.39h-.3V374h.26a.93.93,0,0,0,.83-.33,1.88,1.88,0,0,0,.21-1,1.91,1.91,0,0,0-.15-.84.6.6,0,0,0-.58-.3.54.54,0,0,0-.56.33,2.55,2.55,0,0,0-.15.86v.4h-1.72v-.49a2.88,2.88,0,0,1,.29-1.34,2,2,0,0,1,.83-.85,2.76,2.76,0,0,1,1.31-.29,2.79,2.79,0,0,1,1.31.28,1.9,1.9,0,0,1,.84.82,2.79,2.79,0,0,1,.28,1.33,2.44,2.44,0,0,1-.33,1.32,1.48,1.48,0,0,1-.81.67,1.32,1.32,0,0,1,.59.37,1.7,1.7,0,0,1,.41.68,3.65,3.65,0,0,1,.14,1.07,4.32,4.32,0,0,1-.23,1.45,2.06,2.06,0,0,1-.77,1A2.51,2.51,0,0,1,326,379.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.8,379.5a2.55,2.55,0,0,1-1.35-.34,2.07,2.07,0,0,1-.81-.92,3.24,3.24,0,0,1-.26-1.36v-4.06a3.52,3.52,0,0,1,.25-1.39,2,2,0,0,1,.8-.93,2.91,2.91,0,0,1,2.73,0,2,2,0,0,1,.79.93,3.52,3.52,0,0,1,.25,1.39v4.06a3.4,3.4,0,0,1-.26,1.36,2.07,2.07,0,0,1-.81.92A2.5,2.5,0,0,1,331.8,379.5Zm0-1.52a.5.5,0,0,0,.44-.2,1,1,0,0,0,.18-.45,2.74,2.74,0,0,0,0-.48v-4a3.12,3.12,0,0,0,0-.52,1,1,0,0,0-.17-.46.61.61,0,0,0-.9,0,1,1,0,0,0-.18.46,3.12,3.12,0,0,0,0,.52v4a4.23,4.23,0,0,0,0,.48,1,1,0,0,0,.19.45A.53.53,0,0,0,331.8,378Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.36,379.34V377.7H337v1.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.46,379.5a2.55,2.55,0,0,1-1.35-.34,2,2,0,0,1-.8-.92,3.24,3.24,0,0,1-.27-1.36v-4.06a3.35,3.35,0,0,1,.26-1.39,2,2,0,0,1,.79-.93,2.49,2.49,0,0,1,1.37-.34,2.43,2.43,0,0,1,1.36.34,2,2,0,0,1,.79.93,3.52,3.52,0,0,1,.26,1.39v4.06a3.24,3.24,0,0,1-.27,1.36,2.07,2.07,0,0,1-.81.92A2.48,2.48,0,0,1,340.46,379.5Zm0-1.52a.49.49,0,0,0,.44-.2,1,1,0,0,0,.18-.45,2.74,2.74,0,0,0,0-.48v-4a3.12,3.12,0,0,0,0-.52,1,1,0,0,0-.17-.46.61.61,0,0,0-.9,0,1.11,1.11,0,0,0-.18.46,4.73,4.73,0,0,0,0,.52v4a2.8,2.8,0,0,0,0,.48.92.92,0,0,0,.19.45A.5.5,0,0,0,340.46,378Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.53,379.5a2.55,2.55,0,0,1-1.35-.34,2,2,0,0,1-.8-.92,3.24,3.24,0,0,1-.27-1.36v-4.06a3.52,3.52,0,0,1,.25-1.39,2,2,0,0,1,.8-.93,2.49,2.49,0,0,1,1.37-.34,2.45,2.45,0,0,1,1.36.34,2,2,0,0,1,.79.93,3.52,3.52,0,0,1,.26,1.39v4.06a3.24,3.24,0,0,1-.27,1.36,2.07,2.07,0,0,1-.81.92A2.48,2.48,0,0,1,346.53,379.5Zm0-1.52a.5.5,0,0,0,.44-.2,1,1,0,0,0,.18-.45,2.74,2.74,0,0,0,0-.48v-4a3.12,3.12,0,0,0,0-.52,1,1,0,0,0-.17-.46.51.51,0,0,0-.45-.2.52.52,0,0,0-.45.2,1.11,1.11,0,0,0-.18.46,4.73,4.73,0,0,0,0,.52v4a2.8,2.8,0,0,0,.05.48.92.92,0,0,0,.19.45A.5.5,0,0,0,346.53,378Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-66"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.93,137.32s.4,9.19.2,11.79-2.2,4.8-2.2,6.2,3.4,6.79,1.8,9.39a5.86,5.86,0,0,1-4.2,2.8s-2.8,9.59-5.6,11.39-11.39-3.8-11.39-3.8l-4.2,14-18.19-15.6,7.6-12.39s-3.6-11.39-3.8-19.39,3.4-17,11.6-19.58,12.19-.4,13.39-.4,2.2-5.2,7.59-4.6,5,5.6,7.4,6.8,6.19-2.2,8.59.39a9.77,9.77,0,0,1,.4,12.6C147.32,141.71,141.93,137.32,141.93,137.32Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.93,178.89c2.8-1.8,5.6-11.39,5.6-11.39s-1.8-4.4-4-5.4-12,.4-14.79,1.2-1-10.59-.4-14,4.8-3.6,7.4-3.8,4.79-1.8,4.4-4.4-.8-5.39,2.79-6.59,9,2.8,9,2.8,5.39,4.39,9-.4a9.77,9.77,0,0,0-.4-12.6c-2.4-2.59-6.19.8-8.59-.39s-2-6.2-7.4-6.8-6.39,4.6-7.59,4.6-5.2-2.2-13.39.4-11.8,11.59-11.6,19.58,3.8,19.39,3.8,19.39c2.2-.8,4.6-2.8,4.4-5s0-1-1.6-3.2a6.49,6.49,0,0,1,.8-8.4c2.6-2.8,4.79,3,4.79,3s-3.39,14.59-3.59,18.39,10,9.19,10,9.19S129.14,180.69,131.93,178.89Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.13,156.31c-.34,1-1,1.78-1.38,1.65s-.48-1.1-.14-2.15,1-1.79,1.38-1.65S137.47,155.26,137.13,156.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.13,150.51s3-1.6,5.2.4",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.34,164.3a10.8,10.8,0,0,0,4.19,4",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.74,197.28a40,40,0,0,0-3.8-5.4c-2.6-3.19-4-3.64-3.16-4.54,1.92-1.91,3.16-1,5.75.59a22.08,22.08,0,0,1,4.8,4.35s-4-7-3.79-9,1.6-2.2,3-1.4,3.8,6.6,3.8,6.6a25.86,25.86,0,0,1,5.6,1.39c2.4,1,5.57-.32,5.77,2.48s-3.37,13.71-3.37,13.71l-4.6,24.19s-2.4,16.39-4.6,21.39-4,5.79-4,5.79l-3-20s7.19-28.39,6.79-30.39-3.2-5-4.19-7.39Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.33,192.28s5.2,2.6,6.4,5.6a15.33,15.33,0,0,1,1,6",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.48,179.82s-3.09.3-3.24,1.77.44,3.1,1.62,3.1,3.39-.15,3.69-1.62S131.81,179.38,130.48,179.82Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.74,185s-3,0-2.65,1.48.88,7.37,1.91,7.81,2.66,1,2.81-.44.44-4.42-.15-6.05A7.83,7.83,0,0,0,138.74,185Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.77,185.87a3.68,3.68,0,0,1,3.1.14c1.33.89,1.33,2.07,1.18,4.28s-.74,5.16-1.62,5.46-1.62-1.92-1.62-1.92.73-4.13-.15-6.05Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.2,187.05s2.5.44,2.8,1.91-.44,6.34-1.92,7.52-2.65-.73-2.65-.73a22.66,22.66,0,0,0,1.62-5.46C144.2,188.23,144.2,187.05,144.2,187.05Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.17,203.88l4,43S79.57,280,80,283s1.19,4.2,3,4.2h44.18s4.59-.4,5.39-2.4,1.4-1,1-6-1.4-30.18-2.4-38.78-.4-17.78-3.79-31-6-14-10.6-17.59S104.15,180.89,95,183.29,78.17,203.88,78.17,203.88Z",
    style: {
      fill: "#F09400",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.14,200.08a14.77,14.77,0,0,0-2.6-7.8c-2.6-3.59-10.59-9-14.59-14.39s-11.39-8.59-13.39-7.79A70.58,70.58,0,0,0,79,179.29c-6.2,5-3.2,27-2.2,27.78s13.59-20.58,20.39-21S124.14,200.08,124.14,200.08Z",
    style: {
      fill: "#F09400",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.83,
    y: 169.71,
    width: 2.42,
    height: 24.62,
    rx: 1.1,
    transform: "translate(121.84 -68.27) rotate(31.48)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.36,204.08s-2.4,7.19.4,12.39,27.58,42.17,30.38,42.77,6.6-2.2,6.6-2.2l41.58-49.73s8.13-3.74,10.11-5.5,3.74-6.15,3.74-6.15,3.52-3.52,2.86-6.38-1.76-2.42-2.42-2.2-7.91.66-7.91.66,2.63-3.52,2-5.71-1.75-2.42-2.63-.66-2,3.73-3.08,5.71-5.94,5.5-5.94,7.7-2,9-2,9l-32.9,30.27s-12.2-20.19-12.6-21.79a27.38,27.38,0,0,0-5-12c-4-5.2-6-7.4-10.4-6.8",
    style: {
      fill: "#F09400",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 133.73,
    y1: 229.26,
    x2: 141.93,
    y2: 236.26,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.14,234.06s-5.4,2.6-7,5.19",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.14,234.46s-5.2,7-2.4,9.79",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.61,187.08c-.66.22-7.91.66-7.91.66s2.63-3.52,2-5.71-1.75-2.42-2.63-.66-2,3.73-3.08,5.71-5.94,5.5-5.94,7.7-2,9-2,9L136.84,226l7.67,7.06,21.81-25.77s8.13-3.74,10.11-5.5,3.74-6.15,3.74-6.15,3.52-3.52,2.86-6.38S181.27,186.86,180.61,187.08Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84,455.67s-1,8.61,0,9.33,16.5,1.43,16.5,1.43h22.71a2,2,0,0,0,2.63-.48c1.2-1.43,1.2-5-1.19-6.45s-9.33-2.15-12.44-3.83-7.65-3.58-8.61-4.3-19.36-1.44-19.36-1.44Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.86,466a3,3,0,0,0,.54-1.07c-4.58.41-12.62.93-18,.12-6-.9-18.83-2.62-24.81-3.41,0,1.68.05,3.13.42,3.41,1,.72,16.5,1.43,16.5,1.43h22.71A2,2,0,0,0,125.86,466Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.86,336.11s-.71,19.85-2.39,34-2.87,33.71-5,43.76-2.39,26.78-2.39,26.78l1.2,9.32a6.06,6.06,0,0,0-.48,2.87,17.91,17.91,0,0,1,.24,2.87s-.24.48,7.65.48,10-1.2,10-1.2,3.83-.47.48-21.52-3.83-43-3.83-59.06,1.44-32.52-2.87-41.13S92.86,336.11,92.86,336.11Z",
    style: {
      fill: "#adadad",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.43,450.17l6.69,6s13.87,6,14.59,6.93,0,2.64-.48,3.35-26.06.24-33,.48-10.76.24-11.71-.48-1-11.71-1-11.71S119.88,449.22,124.43,450.17Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.23,466.43a4,4,0,0,0,.7-2.87h-46c.14,1.5.34,2.66.63,2.87,1,.72,4.78.72,11.71.48S144.75,467.15,145.23,466.43Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1,285.42s-.24,19.37,2.39,25.35,8.37,30.6,9.81,41.12-3.83,44.48-2.39,60,6.21,34.68,6.21,34.68-2.87,1.67-2.15,3.58,2.87,7.18,2.87,7.18a37.58,37.58,0,0,0,10.52-1.2c4.79-1.43,17-5,17-5s0-4.07-2.15-6.46-4.78-4.3-5.26-6.93.71-30.85,3.11-60.74,7.17-67.91,7.41-69.58,3.08-22.59,3.08-22.59Z",
    style: {
      fill: "#adadad",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.76,262.07a67.23,67.23,0,0,1-19.62,14.81l1.46,2.51s15.44-8.14,19.2-15.45",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116,292.63c-.27,4.45-1.1,11.25-3.64,14.72-4,5.43-5.63,6-5.63,6",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.13,288.36s0,.62,0,1.65",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106,424.35c.53,7,1.23,12.36,2,13.85,2.3,4.38-.21,6.26,0,8.35s2.92,2.29,2.51,3.54a27.39,27.39,0,0,1-1.26,2.93",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.73,302c.54,7.34,1.2,16.51,1.64,22.71.83,11.9,0,45.7-1.67,58.23-1,7.3-.82,23.4-.06,36.43",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.86,290s.23,3.11.56,7.62",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPorqueWaymenu);
export default __webpack_public_path__ + "static/media/PorqueWaymenu.22a50f20e34bdef3d20b423c55438cd1.svg";
export { ForwardRef as ReactComponent };